import { COMMON_TYPES, TEMPLATE_KEYS } from '../../../helper/commonTypes';
import { upload, history, downloadByRequestId, downloadTemplate } from './commonActionsApi';
import { HTTP_METHOD } from '../../../helper/constants';
import request from '../../request';

const TYPE = COMMON_TYPES.FOCUS_SKU;

export default {
  uploadFocusSku: ({ formData, action }) => upload({ type: TYPE, formData, action }),
  fetchFocusSkuHistory: ({ page = 0, pageSize = 20 } = {}) => history({ type: TYPE, page, size: pageSize }),
  downloadFocusSkuByRequestIdExcel: (requestId) => downloadByRequestId({ requestId }),
  downloadFocusSkuInsertTemplate: () => downloadTemplate({ templateKey: TEMPLATE_KEYS.INSERT[TYPE] }),
  downloadFocusSkuDeleteTemplate: () => downloadTemplate({ templateKey: TEMPLATE_KEYS.DELETE[TYPE] }),
  fetchFocusSku: ({ page = 0, size = 20, category = '' } = {}) => {
    let url = `/skus/all?page=${page}&size=${size}`;
    if (category) {
      url += `&category=${encodeURIComponent(category)}`;
    }
    return request({
      method: HTTP_METHOD.GET,
      url,
      headers: {
      },
    });
  },
  fetchAllCategories: () => {
    const url = '/skus/headerData';
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  downloadFocusSkuAllPdf: () => {
    const url = `/skus/download/pdf?category=ALL`;
    return request({
      method: HTTP_METHOD.GET,
      url,
      responseType: 'blob',
    });
  },
  downloadFocusSkuAllExcel: () => {
    const url = `skus/download/active?category=ALL`;
    return request({
      responseType: 'blob',
      method: HTTP_METHOD.GET,
      url
    })
  }
};